/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Button, MenuItem, OutlinedInput, Select, TextField, ThemeProvider, createTheme } from '@mui/material';
import Grid from '@mui/material/GridLegacy';
import { withStyles } from '@mui/styles';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Switch from '@mui/material/Switch';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getFirmTypes, navigationButtonStyle } from '../common/common';
import { actionCreators } from '../store/UploadDownloads';
import './styles.css';

import classNames from 'classnames';
const theme = createTheme({
    palette: {
        primary: {
            main: '#005f9e'
        },
    },
});
const GridAny: any = Grid;
interface Props {
    classes?: any,
    back: any
    handleSubmit: any
    handleDownloadInformationChange: Function
    handlereleaseDateChange: any
    handleintroductionDateChange: any
    handlefirewareTypeChange: any
    Updatefirmwaretypes: Function
    handleAutoSyncChange: Function
    handleStatusChange: Function

    displayName: any
    autosync: any
    status: any
    revision: any
    description: any
    releaseDate: any
    firmwareType: any,
    introductionDate: any
    firmwaretypes: any
    fileinstructions: any
    comments: any
}

const styles = () => ({
    input: {
        padding: '10px 14px',
        backgroundColor: '#fff'
    },
    textarea: {
        padding: '2px 6px !important',
        backgroundColor: '#fff'
    },
    dateInput: {
        padding: '8px 12px',
        backgroundColor: '#fff'
    },
    selectInput: {
        height: 40,
        backgroundColor: '#fff'
    },
    disabledOption: {
        color: 'gray'
    },
    navigationButton: navigationButtonStyle
})

class DownloadsInformation extends React.Component<Props, {}> {
    state = {
        descriptionError: true,
        revisionError: true,
        releaseDateError: true,
        firmwareTypeError: true,
        introductionDateError: false,

        handleformSubmit: () => {
            if (this.props.releaseDate === undefined) {
                this.setState({ releaseDateError: true });
                return;
            }
            if (this.props.firmwareType === 2 && (this.props.introductionDate === undefined)) {
                this.setState({ introductionDateError: true });
                return;
            }
            const hasError = (this.state.descriptionError || this.state.revisionError || this.state.releaseDateError ||
                this.state.firmwareTypeError || this.state.introductionDateError);
            if (!hasError) {
                this.props.handleSubmit();
            }
        }
    };

    componentDidMount = async () => {
        if (this.props.firmwaretypes.length === 0) {
            const response = await getFirmTypes();
            this.props.Updatefirmwaretypes(response);
        }
        if (this.props.releaseDate !== undefined) {
            this.setState({ releaseDateError: false });
        }
        if (this.props.introductionDate !== undefined) {
            this.setState({ introductionDateError: false });
        }
        if (this.props.description !== undefined && this.props.description.trim() !== '') {
            this.setState({ descriptionError: false });
        }
        if (this.props.revision !== undefined && this.props.revision.trim() !== '') {
            this.setState({ revisionError: false });
        }
        if (this.props.firmwareType !== 0 && this.props.firmwareType !== undefined) {
            this.setState({ firmwareTypeError: false });
        }
    };
    handlereleaseDateChange = (value: any, _context?: any) => {
        const date: Date | null = value as Date | null;
        if (date == null) {
            this.setState({ releaseDateError: true });
            return;
        }
        this.setState({ releaseDateError: false });
        this.props.handlereleaseDateChange(date);
    };
    handlefirewareTypeChange = (event: any) => {
        if (event.target.value === 2 && (this.props.introductionDate === undefined || this.props.introductionDate === '' || this.props.introductionDate == null)) {
            this.setState({ introductionDateError: true });
        }
        else {
            this.setState({ introductionDateError: false });
        }
        this.setState({ firmwareTypeError: false });
        this.props.handlefirewareTypeChange(event);
    };
    handleintroductionDateChange = (value: any, _context?: any) => {
        const date: Date | null = value as Date | null;
        if ((date === undefined || date == null) && this.props.firmwareType === 2) {
            this.setState({ introductionDateError: true });
        }
        else {
            this.setState({ introductionDateError: false });
        }
        this.props.handleintroductionDateChange(date);
    };
    handleChange = (event: any) => {
        this.setState({ [event.target.name + 'Error']: event.target.value.trim() === '' });
        this.props.handleDownloadInformationChange(event);
    };
    handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.props.handleStatusChange(event);
    };
    handleAutoSyncSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.props.handleAutoSyncChange(event);
    };
    isFilled(value: any) {
        if (value == null || value === undefined || value === '' || value.match(/^ *$/) !== null) {
            return false;
        }
        return true;
    }

    render() {
        const { classes, status, autosync, description, revision, releaseDate, firmwareType, introductionDate, fileinstructions, comments } = this.props;
        const { descriptionError, revisionError, releaseDateError, firmwareTypeError, introductionDateError, handleformSubmit } = this.state;
        return (
            <GridAny className="downloadClassification">
                <GridAny className="downloadClassificationGridTitle">4.Fill the Downloads Information </GridAny>
                <GridAny container className="downloadClassificationContainer">
                    <GridAny item xs={12} className="downloadInformationContainerleft">
                        <GridAny container className="downloadsInformationContent">
                            <GridAny item xs={1} className="downloadStatusField downloadsExpandHeaderalign">Status</GridAny>
                            <GridAny item xs={11} className="downloadGrid">
                                <ThemeProvider theme={theme}>
                                    <Switch
                                        checked={status}
                                        onChange={this.handleSwitchChange}
                                        name="checked"
                                        color="primary"
                                    />
                                </ThemeProvider>
                            </GridAny>
                        </GridAny>
                    </GridAny>
                    <GridAny item xs={12} className="downloadInformationContainerleft">
                        <GridAny container>
                            <GridAny item xs={1} className="downloadStatusField downloadsExpandHeaderalign">Auto Sync</GridAny>
                            <GridAny item xs={11} className="downloadGrid">
                                <ThemeProvider theme={theme}>
                                    <Switch
                                        checked={autosync}
                                        onChange={this.handleAutoSyncSwitchChange}
                                        name="checked"
                                        color="primary"
                                    />
                                </ThemeProvider>
                            </GridAny>
                        </GridAny>
                    </GridAny>
                    <GridAny item xs={5} className="downloadInformationContainerleft">
                        <GridAny container className="downloadsInformationContent">
                            <GridAny item xs={3} className="downloadsExpandHeaderalign">Description</GridAny>
                            <GridAny item xs={9}>
                                <TextField
                                    name="description"
                                    className="downloadInputField"
                                    value={description}
                                    onChange={this.handleChange}
                                    variant="outlined"
                                    InputProps={{ classes: { input: classes.input } }}
                                />
                                {descriptionError && <div>* Required</div>}
                            </GridAny>
                        </GridAny>
                        <GridAny container className="downloadsInformationContent">
                            <GridAny item xs={3} className="downloadsExpandHeaderalign">Revision</GridAny>
                            <GridAny item xs={9}>
                                <TextField
                                    name="revision"
                                    className="downloadInputField"
                                    value={revision}
                                    onChange={this.handleChange}
                                    variant="outlined"
                                    InputProps={{ classes: { input: classes.input } }}
                                />
                                {revisionError && <div>* Required</div>}
                            </GridAny>
                        </GridAny>
                        <GridAny container className="downloadsInformationContent">
                            <GridAny item xs={3} className="downloadsExpandHeaderalign">Release Date</GridAny>
                            <GridAny item xs={9}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        format="dd/MM/yyyy"
                                        value={releaseDate ? new Date(releaseDate) : null}
                                        onChange={this.handlereleaseDateChange}
                                        views={["year", "month", "day"]}
                                        disableFuture={true}
                                        disabled={!navigator.onLine}
                                        slotProps={{ textField: { className: "downloadInputField", size: 'small', InputProps: { classes: { input: classes.dateInput } } } }}
                                    />
                                </LocalizationProvider>
                                {releaseDateError && <div>* Required</div>}
                            </GridAny>
                        </GridAny>
                    </GridAny>
                    <GridAny item xs={5} className="downloadItemGrid downloadInformationContainerleft">
                        <GridAny container className="downloadsInformationContent" >
                            <GridAny item xs={3} className="downloadsExpandHeaderalign">FW/File Type</GridAny>
                            <GridAny item xs={9}>
                                <Select
                                    className="downloadInputField"
                                    name="firmWareType"
                                    value={firmwareType}
                                    onChange={this.handlefirewareTypeChange}
                                    variant="outlined"
                                    input={<OutlinedInput classes={{ root: firmwareType === 0 ? classNames(classes.selectInput, classes.disabledOption) : classes.selectInput }} />}>
                                    {this.props.firmwaretypes.map((x: any) => {
                                        return (
                                            <MenuItem className={x.id === 0 && classes.disabledOption} key={x.id} value={x.id}>{x.description}</MenuItem>
                                        );
                                    })
                                    }
                                </Select>
                                {firmwareTypeError && <div>* Required</div>}
                            </GridAny>
                        </GridAny>
                        <GridAny container className="downloadsInformationContent">
                            <GridAny item xs={3} className="downloadsExpandHeaderalign">Introduction Date</GridAny>
                            <GridAny item xs={9}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        format="dd/MM/yyyy"
                                        value={introductionDate != null && introductionDate !== undefined ? new Date(introductionDate) : null}
                                        views={["year", "month", "day"]}
                                        onChange={this.handleintroductionDateChange}
                                        disableFuture={true}
                                        disabled={!navigator.onLine}
                                        slotProps={{ textField: { className: "downloadInputField", size: 'small', InputProps: { classes: { input: classes.dateInput } } } }}
                                    />
                                    {introductionDateError && <div>* Required</div>}
                                </LocalizationProvider>
                            </GridAny>
                        </GridAny>
                    </GridAny>
                    <GridAny item xs={12} className="downloadInformationContainerleft downloadInformationContainerright">
                        <GridAny container className="downloadsInformationContent">
                            <GridAny item xs={1} className="downloadsExpandHeaderalign">File Instructions</GridAny>
                            <GridAny item xs={11} className="downloadGridComments">
                                <TextField
                                    className="downloadInputField"
                                    name="fileinstructions"
                                    value={fileinstructions}
                                    onChange={this.handleChange}
                                    variant="outlined"
                                    multiline
                                    minRows={1}
                                    maxRows={3}
                                    sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#fff' }, '& .MuiOutlinedInput-inputMultiline': { backgroundColor: '#fff', padding: '2px 6px !important' }, '& textarea': { padding: '2px 6px !important' } }}
                                    InputProps={{ classes: { input: classes.textarea, inputMultiline: classes.textarea } }}
                                    inputProps={{ style: { overflowWrap: 'anywhere', wordBreak: 'break-word' } }}
                                />
                            </GridAny>
                        </GridAny>
                    </GridAny>
                    <GridAny item xs={12} className="downloadInformationContainerleft downloadInformationContainerright">
                        <GridAny container className="downloadsInformationContent">
                            <GridAny item xs={1} className="downloadsExpandHeaderalign">Comments</GridAny>
                            <GridAny item xs={11} className="downloadGridComments">
                                <TextField
                                    className="downloadInputField"
                                    name="comments"
                                    value={comments}
                                    onChange={this.handleChange}
                                    variant="outlined"
                                    multiline
                                    minRows={1}
                                    maxRows={3}
                                    sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#fff' }, '& .MuiOutlinedInput-inputMultiline': { backgroundColor: '#fff', padding: '2px 6px !important' }, '& textarea': { padding: '2px 6px !important' } }}
                                    InputProps={{ classes: { input: classes.textarea, inputMultiline: classes.textarea } }}
                                    inputProps={{ style: { overflowWrap: 'anywhere', wordBreak: 'break-word' } }}
                                />
                            </GridAny>
                        </GridAny>
                        </GridAny>
                </GridAny>
                <GridAny>
                    <GridAny container justifyContent="flex-end" className="downloadInformationButton">
                        <Button className={classes.navigationButton} onClick={this.props.back}>Previous</Button>
                        <Button className={classes.navigationButton} onClick={handleformSubmit}>Submit</Button>
                    </GridAny>
                </GridAny>
            </GridAny>
        );
    }
}

const mapStateToProps = (state: any) => ({
    state: state.uploadDownloads,
    displayName: state.uploadDownloads.displayName,
    status: state.uploadDownloads.status,
    autosync: state.uploadDownloads.autosync,
    description: state.uploadDownloads.description,
    revision: state.uploadDownloads.revision,
    releaseDate: state.uploadDownloads.releaseDate,
    introductionDate: state.uploadDownloads.introductionDate,
    firmwaretypes: state.uploadDownloads.firmwaretypes,
    firmwareType: state.uploadDownloads.firmwareType,
    fileinstructions: state.uploadDownloads.fileinstructions,
    comments: state.uploadDownloads.comments
});

const mapDispatchtoProps = (dispatch: any) =>
    bindActionCreators(actionCreators, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchtoProps
)(withStyles(styles as any)(DownloadsInformation as any) as any);
